export enum ProductionStatusEnum {
  CREATED = "CREATED",
  STARTED = "STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  FINISHED = "FINISHED",
  ABORTED = "ABORTED",
  FAILED = "FAILED",
}

/**
 * State when production has not been started yet.
 */
export const ProductionStatusNotStartedSet = new Set<ProductionStatusEnum>([
  ProductionStatusEnum.CREATED,
]);

/**
 * States when production is actively running.
 */
export const ProductionStatusActiveSet = new Set<ProductionStatusEnum>([
  ProductionStatusEnum.STARTED,
  ProductionStatusEnum.IN_PROGRESS,
]);

/**
 * States when production has failed or been aborted.
 */
export const ProductionStatusFailedSet = new Set<ProductionStatusEnum>([
  ProductionStatusEnum.ABORTED,
  ProductionStatusEnum.FAILED,
]);

/**
 * States when production is NOT running at the moment.
 * Includes both never-started and already finished states.
 */
export const ProductionStatusInactiveSet = new Set<ProductionStatusEnum>([
  ProductionStatusEnum.CREATED,
  ProductionStatusEnum.FINISHED,
  ProductionStatusEnum.ABORTED,
  ProductionStatusEnum.FAILED,
]);

/**
 * Final states after which production will not change anymore.
 * Includes both successful and unsuccessful completions.
 */
export const ProductionStatusTerminalSet = new Set<ProductionStatusEnum>([
  ProductionStatusEnum.FINISHED,
  ProductionStatusEnum.ABORTED,
  ProductionStatusEnum.FAILED,
]);

/**
 * State when production has successfully finished.
 */
export const ProductionStatusFinishedSet = new Set<ProductionStatusEnum>([
  ProductionStatusEnum.FINISHED,
]);
